import React from 'react';
import { View, Image, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS, ADMIN_FONT } from '../../../config/theme/adminColors';

// Proporções reais do asset assets/mockupIOS.png (368x750), medidas a partir
// da área transparente da tela (onde o conteúdo aparece por trás do vidro).
const FRAME_W = 368;
const FRAME_H = 750;
const SCREEN_LEFT = 20;
const SCREEN_RIGHT = 20;
const SCREEN_TOP = 44;
const SCREEN_BOTTOM = 20;

// Moldura de iPhone reutilizável para pré-visualizações de personalização.
// O conteúdo (children) fica posicionado atrás da imagem do aparelho, que
// tem a "tela" recortada (transparente) — por isso o bezel cobre as bordas
// naturalmente e não precisamos recortar o conteúdo manualmente.
export function PhoneMockup({ width = 220, label, children, statusBarColor }) {
  const scale = width / FRAME_W;
  const height = FRAME_H * scale;

  const screenLeft = SCREEN_LEFT * scale;
  const screenRight = SCREEN_RIGHT * scale;
  const screenTop = SCREEN_TOP * scale;
  const screenBottom = SCREEN_BOTTOM * scale;

  return (
    <View style={styles.wrapper}>
      <View style={{ width, height }}>
        <View
          style={[
            styles.screen,
            {
              left: screenLeft,
              right: screenRight,
              top: screenTop,
              bottom: screenBottom,
              // Cantos de cima retos: o conteúdo encosta reto na faixa da status
              // bar (sem vãos nos cantos, e a curva do topo fica na cor da
              // status bar, coberta pela moldura). Só os cantos de baixo curvam.
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 22 * scale,
              borderBottomRightRadius: 22 * scale,
            },
          ]}
        >
          {children}
        </View>
        {/* Faixa da status bar (cor "Barra de status superior"): preenche a área
            do topo da tela — entre o notch e o início do conteúdo — que antes
            ficava branca. Fica atrás da moldura, então o notch aparece por cima,
            como numa status bar real. */}
        {statusBarColor ? (
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: screenLeft,
              right: screenRight,
              height: screenTop,
              backgroundColor: statusBarColor,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
            }}
          />
        ) : null}
        <Image
          source={require('../../../../assets/mockupIOS.png')}
          style={{ width, height }}
        />
      </View>
      {label ? <Text style={styles.label}>{label}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
  },
  screen: {
    position: 'absolute',
    overflow: 'hidden',
  },
  label: {
    marginTop: 10,
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    fontWeight: '600',
    color: ADMIN_COLORS.ink,
    textAlign: 'center',
  },
});
